var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lv-risk-icon",class:[_vm.color,{ zero: _vm.num=='0' }],style:({
    color: _vm.num=='0' ? null : _vm.color,
    'background-color': _vm.num=='0' ? null : _vm.backgroundColor
  })},[_c('i',{class:_vm.leadingIcon}),_c('LvText',{attrs:{"h4":"","bold":"","light-gray":""}},[_vm._v(_vm._s(_vm.num))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }